import cn from 'classnames';
import { PanelLink } from '@creditflowresearch/uilib/PanelControl';
import { ISectionItem } from '@creditflowresearch/uilib/Section';

import styles from './sectionItem.module.scss';

interface ISectionItemProps {
  item: ISectionItem,
  dataTest?: string,
}
const SectionItem = ({ item, dataTest = 'sectionItem' }: ISectionItemProps) => (
  <li
    data-test={ dataTest }
    className={ cn(styles.item, { [styles.disabled]: item.disabled, [styles.isActive]: item.isActive }) }
  >
    { item.href && !item.disabled ? (
      <PanelLink
        to={ item.href }
        className={ cn(styles.itemLink, { [styles.isActive]: item.isActive }) }
      >
        { item.label }
      </PanelLink>
      ) : (
        <span
          className={ styles.itemText }
          onClick={ item.onClick && !item.disabled ? item.onClick : undefined }
          role={ item.onClick && !item.disabled ? 'button' : undefined }
          tabIndex={ item.onClick && !item.disabled ? 0 : undefined }
        >
          { item.label }
        </span>
      ) }
  </li>
  );

export default SectionItem;
